module.exports = __webpack_public_path__ + "static/media/ending-fye.de6cf671.png";